const Cache = new Map();
import Api from '@/script/api';
import Message from '@/script/Message'
import Call from '@/script/call';
import Utils from '@/script/store';
import { rewriteLegacyDeliCosUrl } from '@/utils/cosUrl';

const state = {
    currentUrl: "",     //当前操作url
    multiEdit: false,   //是否多选
    multiUrls: [],      //多选url
    showEdit: false,    //是否显示编辑框
    websdk: null,       //websdk实例
    _resolve: null,
    _reject: null,
    actionFunction: null,
    actionConfig: {},
};

const mutations = {
    SET_WEBSDK(state, YKT_WEBSDK) {
        state.websdk = new YKT_WEBSDK();
    },
    UPDATE_SHOW_EDIT(state, show) {
        state.showEdit = show;
    },
    SHOW_EDIT(state, url) {
        state.currentUrl = rewriteLegacyDeliCosUrl(url);
        state.showEdit = true;
    },
    // 打开编辑框
    OPEN(state, payload) {
        state.currentUrl = rewriteLegacyDeliCosUrl(payload.url);
        state._resolve = payload.resolve;
        state._reject = payload.reject;
        state.showEdit = true;
    },
    CLOSE(state) {
        state.currentUrl = "";
        state.showEdit = false;
        state.actionFunction = null;
        state.actionConfig = {};
        state._resolve = null;
        state._reject = null;
    },
    SET_CURRENT_ACTION(state, payload) {
        const { action, config } = payload;
        state.actionFunction = action;
        state.actionConfig = config;
    },
    SET_YKT_WRAPPER(state, payload) {
        Cache.set(payload.action, payload.wrapper);
    },
    CLEAR_YKT_WRAPPER(state) {
        Cache.clear();
    },
    // 开启批量编辑
    UPDATE_MULTI_EDIT(state, value) {
        state.multiEdit = value;
    },
    // 设置url列表
    UPDATE_MULTI_URLS(state, value) {
        state.multiUrls = rewriteLegacyDeliCosUrl(value);
    }
};

const actions = {
    async initWebSdk({ commit, state }) {
        if (state.websdk) return;
        try {
            const { YKT_WEBSDK, warning } = await window.YKT_SW.ready()
            if (!warning.length) {
                console.warn("初始化【YKT】", warning)
            }
            commit("SET_WEBSDK", YKT_WEBSDK);
        } catch (error) {
            console.log("初始化【YKT】遇到错误: ", error.message);
        }
    },
    editImage({ commit }, data) {
        return new Promise(async (resolve, reject) => {
            // 判断用户是否有注册isvUserId
            const user = getUserInfo();
            if (!user) {
                Message.error("请检查用户是否登录")
                return;
            }
            if (!user?.isvUserId) {
                let res = await Api.post("/admintooltaobaoaccount/saveisvuserid");
                if (res?.code == 1 && res?.info) {
                    user.isvUserId = res.info;
                    Call.sendSync("session.saveUser", user);
                    Utils.save("user-info", user);
                    let uu = await Call.invoke('YKT.createUser', res.info);
                    if (uu.code != 200) {
                        return Message.error(uu.reason || uu.result)
                    }
                    console.log("新增【YKT】用户成功");
                } else {
                    return Message.error(user.err || user.msg);
                }
            }
            commit('OPEN', { url: data.url, resolve, reject });
        });
    },
    submit({ state, commit }, result) {
        if (state._resolve) state._resolve(result);
        commit('CLOSE');
    },
    cancel({ state, commit }) {
        if (state._reject) state._reject('cancelled');
        commit('CLOSE');
    },
    getEditWrapper({ state }) {
        if (Cache.has(state.actionFunction)) {
            const func = Cache.get(state.actionFunction);
            console.log("获取到的【YKT】函数实例", func);
            return func;
        }

        return null;
    },
};

const getters = {};
function getUserInfo() {
    var s = localStorage.getItem("user-info");
    if (s) {
        return JSON.parse(s);
    }
    if (window.require) {
        return window.vue.$call.sendSync("session.getUser");
    }
    return;
}
export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
